import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Script from 'react-load-script';

import { GOOGLE_MAP_URL } from '../../constants/defaults';

import { errorOpen } from '../../actions/step';

import { getPlacesAdress, getUserInfo } from '../../actions/inquires';

const unactiveBtnStyle = {
  background: '#ccc',
  cursor: 'default'
};

const countryRestrict = { country: 'fr' };

class ClassInputPlaces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null
    };
    this.handleChange = this.handleChange.bind(this);
    this.inputValidate = this.inputValidate.bind(this);
    this.handleScriptLoad = this.handleScriptLoad.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
  }

  handleScriptLoad() {
    /*global google*/
    this.autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { componentRestrictions: countryRestrict }
    );
    this.autocomplete.addListener('place_changed', () =>
      this.handlePlaceSelect(this.autocomplete.getPlace())
    );
  }

  handleChange(event) {
    console.log(event);

    this.props.getUserInfo(event.target.value, 'address');
    this.props.getPlacesAdress('adress', event.target.value);
  }

  generateOptions(data) {
    var options = data.split(',');
    return options.map(i => {
      return { value: i, label: i };
    });
  }
  inputValidate() {
    return this.props.inquires.places.adress.length >= 2;
  }
  handlePlaceSelect(e) {
    if (this.inputValidate()) {
      let addressObject = e;

      if (addressObject.address_components) {
        addressObject.address_components.map(addr => {
          if (addr.types[0] === 'postal_code') {
            console.log(addr.long_name);
            addressObject.zip_code = addr.long_name;
          }
          if (addr.types[0] === 'locality') {
            console.log(addr.long_name);
            addressObject.city = addr.long_name;
          }
          if (addr.types[0] === 'street_number') {
            addressObject.nb_street = addr.long_name;
          }
        });
      }

      if (addressObject.geometry) {
        this.props.getPlacesAdress('adress', addressObject.formatted_address);
        this.props.getPlacesAdress(
          'lat',
          Number(addressObject.geometry.location.lat())
        );
        this.props.getPlacesAdress(
          'lng',
          Number(addressObject.geometry.location.lng())
        );
      } else {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          {
            address: addressObject.name,
            componentRestrictions: countryRestrict
          },
          (results, status) => {
            if (
              status == google.maps.GeocoderStatus.OK &&
              results[0].formatted_address !== 'France'
            ) {
              this.props.getPlacesAdress(
                'adress',
                results[0].formatted_address
              );
              this.props.getPlacesAdress(
                'lat',
                Number(results[0].geometry.location.lat())
              );
              this.props.getPlacesAdress(
                'lng',
                Number(results[0].geometry.location.lng())
              );
            } else {
              this.props.getPlacesAdress('adress', '');
              this.props.getPlacesAdress('lat', null);
              this.props.getPlacesAdress('lng', null);
              this.props.errorOpen(
                'Erreure Adresse',
                "L'adresse " +
                  addressObject.name +
                  ' est invalide, merci de renseigner une adresse valide'
              );
            }
          }
        );
      }
      this.props.getUserInfo(addressObject.formatted_address, 'address');
      this.props.getUserInfo(addressObject.zip_code, 'zip_code');
      this.props.getUserInfo(addressObject.city, 'city');
    }
  }
  render() {
    return (
      <div>
        <Script
          url={GOOGLE_MAP_URL}
          onLoad={this.handleScriptLoad}
        />
        <input
          id="autocomplete"
          className="inputPlaces fontMedium"
          placeholder="Entrez votre adresse"
          name="address"
          value={this.props.inquires.places.adress}
          onChange={e => this.handleChange(e)}
        />
        {this.props.step.pageNumber != 1 ? (
          <button
            className="inputCta ctaRed fontMedium colorBlack"
            disabled={!this.inputValidate()}
            style={this.inputValidate() ? null : unactiveBtnStyle}
            onClick={() =>
              this.handlePlaceSelect({
                name: this.props.inquires.places.adress
              })
            }
          >
            Rechercher
          </button>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      errorOpen,
      getUserInfo,
      getPlacesAdress
    },
    dispatch
  );

export const InputPlaces = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassInputPlaces);



// WEBPACK FOOTER //
// ./src/containers/components/InputPlaces.js